import { Box } from "@mui/material";

interface Props {
  /** the twin's id(s) - the tag renders nothing when empty */
  ids: string[];
  /** "DUPLICATE OF" on a config, "POSSIBLE DUPLICATE OF" on a report */
  prefix?: string;
  /**
   * true when this copy has no brands on it, so deleting it is safe. The
   * mockup turns the tag red in that case and leaves it amber otherwise.
   */
  isDead?: boolean;
  title?: string;
  onClick: () => void;
}

// straight from the mockup's .twinlink / .twinlink.dead rules.
const LIVE = {
  backgroundColor: "#FBF0E1",
  color: "#B45309",
  borderColor: "#E8CFA4",
  hoverBackgroundColor: "#F6E3C4",
};
const DEAD = {
  backgroundColor: "#FBE9E9",
  color: "#C0392B",
  borderColor: "#F0C9C4",
  hoverBackgroundColor: "#F7DAD8",
};

const DuplicateOfTag = ({
  ids,
  prefix = "DUPLICATE OF",
  isDead = false,
  title,
  onClick,
}: Props) => {
  if (ids.length === 0) return null;
  const palette = isDead ? DEAD : LIVE;
  return (
    <Box
      component="span"
      role="button"
      tabIndex={0}
      title={title}
      onClick={(event) => {
        event.stopPropagation();
        onClick();
      }}
      onKeyDown={(event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.stopPropagation();
        event.preventDefault();
        onClick();
      }}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        padding: "2px 7px",
        borderRadius: "4px",
        fontSize: "11px",
        fontWeight: 600,
        whiteSpace: "nowrap",
        cursor: "pointer",
        border: "1px solid",
        backgroundColor: palette.backgroundColor,
        color: palette.color,
        borderColor: palette.borderColor,
        "&:hover": { backgroundColor: palette.hoverBackgroundColor },
      }}
    >
      ⧉ {prefix} {ids.join(", ")}
    </Box>
  );
};

export default DuplicateOfTag;
